<script setup lang="ts">
import { computed } from 'vue'
import type { ProcessamentoResult } from '@/types'

interface Props {
  resultado: ProcessamentoResult | null
}

interface Emits {
  (e: 'nova-importacao'): void
  (e: 'exportar-relatorio'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const taxaSucesso = computed(() => {
  if (!props.resultado || props.resultado.total === 0) return 0
  return Math.round((props.resultado.inseridos / props.resultado.total) * 100)
})
</script>

<template>
  <v-card v-if="resultado" class="mb-4" variant="outlined">
    <v-card-text class="py-3">
      <!-- Cabeçalho + contadores em uma única faixa -->
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div class="d-flex align-center ga-2">
          <v-icon size="small" :color="resultado.inseridos > 0 ? 'success' : 'warning'">
            {{ resultado.inseridos > 0 ? 'mdi-check-circle' : 'mdi-alert-circle' }}
          </v-icon>
          <span class="text-subtitle-2 font-weight-medium">Resultado da importação</span>
        </div>

        <div class="d-flex align-center ga-2 flex-wrap">
          <v-chip size="small" color="success" variant="tonal" prepend-icon="mdi-check">
            {{ resultado.inseridos }} inseridos
          </v-chip>
          <v-chip
            v-if="resultado.duplicados > 0"
            size="small"
            color="warning"
            variant="tonal"
            prepend-icon="mdi-content-copy"
          >
            {{ resultado.duplicados }} duplicados
          </v-chip>
          <v-chip
            v-if="resultado.erros > 0"
            size="small"
            color="error"
            variant="tonal"
            prepend-icon="mdi-alert"
          >
            {{ resultado.erros }} com erro
          </v-chip>
        </div>
      </div>

      <!-- Linha de detalhes (compacta) -->
      <div class="d-flex align-center flex-wrap ga-4 text-caption text-medium-emphasis mt-2">
        <span v-if="resultado.info?.nomeArquivo">
          <v-icon size="14" class="mr-1">mdi-file-excel</v-icon>{{ resultado.info.nomeArquivo }}
        </span>
        <span><v-icon size="14" class="mr-1">mdi-counter</v-icon>Total: {{ resultado.total }}</span>
        <span><v-icon size="14" class="mr-1">mdi-percent</v-icon>Sucesso: {{ taxaSucesso }}%</span>
      </div>

      <!-- Ações -->
      <div class="d-flex justify-end ga-2 mt-3">
        <v-btn
          variant="text"
          size="small"
          prepend-icon="mdi-download"
          @click="emit('exportar-relatorio')"
        >
          Exportar Relatório
        </v-btn>
        <v-btn
          color="primary"
          variant="elevated"
          size="small"
          prepend-icon="mdi-plus"
          @click="emit('nova-importacao')"
        >
          Nova Importação
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>
